import React from 'react'
import { FieldProps } from '../FormDuuf'

// Elements
import Label from '../elements/Label'
import Error from '../elements/Error'

const CheckboxesField: React.FC<FieldProps> = ({
  formik = { handleBlur: () => null, handleChange: () => null, values: {} },
  hasError = false,
  fieldId,
  data
}) => {
  const choices = JSON.parse(data.choices)

  return (
    <div className={`form-duuf-group form-duuf-group-${data.type} form-duuf-checkboxes-${fieldId}`}>
      <Label fieldId={fieldId} data={data} />
      <Error fieldId={fieldId} data={data} hasError={hasError} formik={formik} />
      <div className={`form-duuf-choices-${fieldId}`}>
        {choices.map((choice, index) => {
          const isChecked = formik.values[`${fieldId}_${index}`] ? formik.values[`${fieldId}_${index}`] === choice.value : false

          return (
            <div className="d-flex align-items-center" key={choice.value}>
              <input
                type="checkbox"
                className={`form-duuf-checkbox form-duuf-checkbox-${data.type}`}
                id={choice.value}
                name={fieldId}
                placeholder={data.placeholder}
                onBlur={formik.handleBlur}
                onChange={(event) => {
                  // @ts-ignore
                  formik.handleChange({
                    target: {
                      name: `${event.target.name}_${index}`,
                      value: !isChecked ? event.target.value : ''
                    }
                  })
                }}
                value={choice.value}
                checked={isChecked}
              />
              <label htmlFor={choice.value} className={`form-duuf-checkbox-label form-duuf-checkbox-${data.type}`}>
                {choice.text}
              </label>
            </div>
          )
        })}
      </div>
    </div>
  )
}

export default CheckboxesField
